import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-hawthorne')!;

const HawthornePage = () => <CityLandingPage data={data} />;

export default HawthornePage;
